<template>
  <div class="flex flex-1 items-center justify-center">
    <ESpinner size="2xl" />
  </div>
</template>

<script setup>
import { ESpinner } from '@expansivefm/eds'
</script>
